import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Research from './pages/Research';
import About from './pages/About';
import CV from './pages/CV';
import Thesis from './pages/Thesis';
import Contact from './pages/Contact';
import SonicArtifacts from './pages/SonicArtifacts';
import SonicPlayer from './pages/SonicPlayer';
import SonicAdmin from './pages/SonicAdmin';

// ScrollToTop component
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/thesis" element={<Thesis />} />
            <Route path="/research" element={<Research />} />
            <Route path="/about" element={<About />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/sonic" element={<SonicArtifacts />} />
            <Route path="/sonic/play/:id" element={<SonicPlayer />} />
            <Route path="/sonic/admin" element={<SonicAdmin />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;